import * as angular from 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';
import { ColorsModalFacade } from '@mode/charts/contract';
import { ComponentsModule } from '~/core-app/components';
import { DowngradedExplorationsShellModule } from '~/modules/downgraded-angular/explorations/shell.module';
import { DowngradedReportViewerShellModule } from '~/modules/downgraded-angular/report-viewer/shell.module';
import { CheckboxToggleModule } from '~/modules/org-settings/common/checkbox-toggle/checkbox-toggle.module';
import { DowngradedChartsDomainModule } from '../../downgraded-angular/charts/domain.module';
import { DowngradedChartsFeatureEncodingModule } from '../../downgraded-angular/charts/feature-encoding.module';
import { DowngradedChartsUIModule } from '../../downgraded-angular/charts/ui.module';
import { DowngradedSharedUIModule } from '../../downgraded-angular/shared/ui.module';
import { DowngradedSwitchViewsFeatureDatasetOverviewModule } from '../../downgraded-angular/switch-views/feature-dataset-overview.module';
import { DowngradedSwitchViewsFeatureFieldlistModule } from '../../downgraded-angular/switch-views/feature-fieldlist.module';
import { DowngradedSwitchViewsFeatureQueryModule } from '~/modules/downgraded-angular/switch-views/feature-query.module';
import { DowngradedSwitchViewsUIModule } from '~/modules/downgraded-angular/switch-views/ui.module';
import { AppServicesModule } from '../../mode-app-services';
import { SharedServicesModule } from '../../mode-shared-services';
import { SharedUiModule } from '../../shared-ui/shared-ui.module';
import { BigValueDesignerRendererComponent } from './big-value-designer-renderer/designer-renderer-big-value.component';
import { ColorPalettesDropdownComponent } from './color-palettes-dropdown/color-palettes-dropdown.component';
import { DesignerEmptyTableComponent } from './designer-empty-table/designer-empty-table.component';
import { DesignerErrorComponent } from './designer-error/designer-error.component';
import { DesignerRendererComponent } from './designer-render/designer-renderer.component';
import { EmptyChartStateComponent } from './empty-chart-state/empty-chart.component';
import { OrderByNaturalFilter } from './order-by-natural/order-by-natural-filter';
import { VizSettingsModule } from './viz-settings/viz-settings.module';
import { VizToolbarComponent } from './viz-toolbar/viz-toolbar.component';

export const ReportUiModule = angular
  .module('report-ui', [
    SharedUiModule,
    AppServicesModule,
    SharedServicesModule,
    ComponentsModule,
    DowngradedChartsDomainModule,
    DowngradedChartsUIModule,
    DowngradedChartsFeatureEncodingModule,
    DowngradedSwitchViewsFeatureFieldlistModule,
    DowngradedSwitchViewsFeatureDatasetOverviewModule,
    DowngradedSwitchViewsFeatureQueryModule,
    DowngradedSwitchViewsUIModule,
    DowngradedSharedUIModule,
    DowngradedReportViewerShellModule,
    DowngradedExplorationsShellModule,
    VizSettingsModule,
    CheckboxToggleModule,
  ])
  .component('designerRenderer', DesignerRendererComponent)
  .component('vizToolbar', VizToolbarComponent)
  .component('designerEmptyTable', DesignerEmptyTableComponent)
  .component('designerError', DesignerErrorComponent)
  .component('bigValueDesignerRenderer', BigValueDesignerRendererComponent)
  .component('emptyChartState', EmptyChartStateComponent)
  .component('colorPalettesDropdown', ColorPalettesDropdownComponent)
  .filter('orderByNatural', OrderByNaturalFilter)
  .service('ColorsModalFacade', downgradeInjectable(ColorsModalFacade)).name;
